import React from 'react';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { notesPendingActionActions } from '_actions';

class NotesPendingActionListItem extends React.Component {
    render() {
        var options = { year: '2-digit', month: 'numeric', day: 'numeric' };
        return (

            <div
                className={
                    this.props.message.id === this.props.selectedMessage ? messageCenterCommonStyles.selected_message :
                        this.props.message.isRead === true ? messageCenterCommonStyles.read_message : messageCenterCommonStyles.unread_message
                }
                onClick={() => this.props.changeMessage(this.props.message.id)}>
                {this.props.message.ptname + " - " + this.props.noteAbbrev + " " + new Date(this.props.message.noteDate).toLocaleDateString("en-US", options)}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        message: state.entities.notesPendingAction[ownprops.id],
        noteAbbrev: state.entities.masterData.PTMASTERNOTETYPES && 
            state.entities.masterData.PTMASTERNOTETYPES[state.entities.notesPendingAction[ownprops.id].noteType] ?
            state.entities.masterData.PTMASTERNOTETYPES[state.entities.notesPendingAction[ownprops.id].noteType].MTABBREV :
            "",
        selectedMessage: state.ui.notesPendingAction.selectedMessage,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeMessage: bindActionCreators(notesPendingActionActions.changeSelection, dispatch)
    };
}

const connectedNotesPendingActionListItem = connect(mapStateToProps, mapDispatchToProps)(NotesPendingActionListItem);
export { connectedNotesPendingActionListItem as NotesPendingActionListItem };